import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import { StatesEnum } from '../../shared/enums/states.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { castTo } from '../../shared/utils/cast-to';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { AppsFilters } from '../models/apps-filters.model';

export const getAppsTotalCount: AsyncThunk<
  number,
  Partial<AppsFilters> | undefined,
  Record<string, unknown>
> = createAsyncThunk(
  'apps/get-apps-total-count',
  async (filters: Partial<AppsFilters> | undefined): Promise<number> => {
    const mandantId = localStorageService.get(
      LocalStorageProperties.SELECTED_MANDANT
    ) as string | null;

    const updateFilters: Partial<AppsFilters> | undefined = {
      ...filters,
      ...(filters?.status && {
        status: castTo<StatesEnum>(filters?.status.toUpperCase()),
      }),
      ...(filters?.categories && { categories: filters?.categories }),
      ...(filters?.platforms && { platforms: filters?.platforms }),
    };

    const basePath =
      Endpoints.APPS_TOTAL_COUNT +
      createQueryParams({
        ...updateFilters,
        ...(mandantId !== null && { mandant: parseInt(mandantId, 10) }),
      });

    const { data }: AxiosResponse<number> = await axiosInstance.get(basePath);

    return data;
  }
);
